/** Internal Request Generic Service */

const InternalRequestService = {
  /**
   * Generate location options of a given inventory locations instance for the inventory select form
   * @param {array} inventoryLocations - array of inventory locations from an item's inventory
   */
  generateLocationOptions: (inventoryLocations = []) => (
    (inventoryLocations || [])
      .filter((inventory_location) => !!inventory_location)
      .map((inventory_location) => {
        const value = inventory_location.location_id || inventory_location.id
        const label = inventory_location.label || `${inventory_location.location || inventory_location.type_name || '-'}[${inventory_location.sublocation || inventory_location.name || '-'}]`

        return {
          value : value,
          label : label
        }
      })
      .filter((option) => !!option.value)
      .filter((option, index, array) => array.findIndex((row) => row.value === option.value) === index)
  ),

  /**
   * Generate quantity to borrow for an item.
   * Internal Request uses IQ/stored quantity because items can be borrowed
   * before product is Live, as long as the product is physically available in store.
   * @param {number} storedQuantity - inventory's stored quantity / IQ
   */
  getQuantityToBorrow: (storedQuantity) => (
    Number(storedQuantity || 0)
  ),

  /**
   * TODO: move to internal-request-ops/services
   */
  generatePrintPickingListData: (items) => {
    const header = [
      [
        'SKU',
        'Name',
        'Size',
        // TODO: location
        'Requested Quantity',
        'Quantity in Warehouse',
        'Quantity Available'
      ]
    ]

    const transformedItems = items.map((item) => {
      const { inventory } = item

      return [
        inventory && inventory.inventory_sku,
        inventory && inventory.product && inventory.product.name,
        inventory && inventory.product_dimension && inventory.product_dimension.size,
        item.quantity,
        // TODO: location
        inventory && inventory.stored_quantity,
        InternalRequestService.getQuantityToBorrow(inventory && inventory.stored_quantity)
      ]
    })

    return { header: header, data: transformedItems }
  }
}

export default InternalRequestService
